import clsx from 'clsx'
import { RANK_CONFIG } from '../../data/mock'
import type { Rank } from '../../types'

interface RankBadgeProps {
  rank: Rank
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
  className?: string
}

export default function RankBadge({ rank, size = 'sm', showLabel = true, className }: RankBadgeProps) {
  const config = RANK_CONFIG[rank]

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 font-semibold rounded-full',
        size === 'sm' && 'px-2 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm',
        size === 'lg' && 'px-4 py-1.5 text-base',
        className,
      )}
      style={{
        backgroundColor: `${config.color}20`,
        color: config.color,
      }}
    >
      <span
        className={clsx(
          'rounded-full',
          size === 'sm' && 'w-2 h-2',
          size === 'md' && 'w-2.5 h-2.5',
          size === 'lg' && 'w-3 h-3',
        )}
        style={{ backgroundColor: config.color }}
      />
      {showLabel && config.label}
    </span>
  )
}
